import { Social } from '../../../enums/socials'
import {
  IconFollowFacebook,
  IconFollowInstagram,
  IconFollowYoutube,
  IconFollowTwitter,
  IconFollowTelegram,
  IconFollowLinkedin,
  IconFollowTikTok
} from './../../../assets/svg/index'

export const socialIcons: Record<string, React.FC> = {
  [Social.Facebook]: IconFollowFacebook,
  [Social.Instagram]: IconFollowInstagram,
  [Social.Youtube]: IconFollowYoutube,
  [Social.Twitter]: IconFollowTwitter,
  [Social.Telegram]: IconFollowTelegram,
  [Social.Linkedin]: IconFollowLinkedin,
  [Social.TikTok]: IconFollowTikTok
}
